module.exports = __webpack_public_path__ + "static/img/backgroundHome2.fb993f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backgroundHome2.png
// module id = 0mH7
// module chunks = 13